import * as React from 'react';
import styled from 'styled-components';
import { Box } from '@origin-digital/layout';
import { BREAK_POINTS, Heading2, Metrics, Text } from '@origin-digital/style-guide';
import { HeadingLink, headingLinkOnHoverMixin } from '../Text';
import { Link } from '../Link';
import { IProofPoints, IProofPointsItem } from '../../models/content.interfaces';

export const Container = styled.div`
  > a {
    margin-bottom: 24px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: flex;
    > a {
      flex: 1 1 0;
      margin-bottom: 0;
    }
    > a:first-child {
      margin-right: ${Metrics.Spacing.M_X_SM}px;
    }
    > a:last-child {
      margin-left: ${Metrics.Spacing.M_X_SM}px;
    }
    &:not(:last-child) {
      margin-bottom: 48px;
    }
  }
`;

const Heading = styled(Heading2)`
  text-align: left;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    text-align: center;
  }
`;

const IconRowLink = styled(Link)`
  display: flex;
  box-sizing: border-box;
  color: black;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  ${headingLinkOnHoverMixin};
`;

export const IconRow: React.FunctionComponent<{
  item: IProofPointsItem;
}> = ({ item }) => (
  <IconRowLink href={item.href} data-id={item['data-id']} target={item.newTab ? '_blank' : '_self'}>
    <Box marginRight={4}>
      <span dangerouslySetInnerHTML={{ __html: item.iconSvg }} />
    </Box>
    <Box>
      <Box marginBottom={2}>
        <HeadingLink>{item.heading}</HeadingLink>
      </Box>
      <Text size="sm">{item.description}</Text>
    </Box>
  </IconRowLink>
);

export const ProofPoints: React.FunctionComponent<IProofPoints> = ({
  heading = "Join Australia's largest energy retailer",
  items,
}) => (
  <div>
    <Heading text={heading} marginBottom />
    <Container>
      <IconRow item={items[0]} />
      <IconRow item={items[1]} />
    </Container>
    <Container>
      <IconRow item={items[2]} />
      <IconRow item={items[3]} />
    </Container>
  </div>
);

ProofPoints.displayName = 'ProofPoints';
